// Third-party
import React from 'react';

// Components
import DatesDisclaimer from './DatesDisclaimer';

// Utils
import { getCharacteristicsAsAtDates, getInvestmentInfoDates } from '../../../../utils/disclaimers/comparison';
import { formatMessageWithLocale } from '../../../../utils/i18n';
import { DISCLAIMER_KEYS } from '../../../../utils/disclaimers/constants';
import { COMPARISON_ITEM_TYPES } from '../../../../utils/constants';
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';

interface Props {
  items: ComparisonItem[];
  showItemNames?: boolean;
  locale?: Locale;
}

const ReturnOnEquityDisclaimer = ({ items, locale, showItemNames }: Props) => {
  const equityItems = items.filter(
    i =>
      !!i.disclaimers &&
      !i.disclaimers[DISCLAIMER_KEYS.FUND_EQUITY_METRICS_NOT_APPLICABLE] &&
      !i.disclaimers[DISCLAIMER_KEYS.PORTFOLIO_EQUITY_METRICS_NOT_APPLICABLE],
  );

  const stockItems = items.filter(i => i.type === COMPARISON_ITEM_TYPES.STOCK);
  const itemDates = getCharacteristicsAsAtDates(equityItems).concat(getInvestmentInfoDates(stockItems, locale));

  return (
    <DatesDisclaimer
      globalPrefix={formatMessageWithLocale('Disclaimers.ReturnOnEquity', locale)}
      itemPrefix={formatMessageWithLocale('Disclaimers.AsAt', locale)}
      itemDates={itemDates}
      showItemNames={showItemNames}
      locale={locale}
    />
  );
};

export default ReturnOnEquityDisclaimer;
